import { create } from 'zustand';

const useModalsStore = create((set) => ({
  isOpenGamesModal: false,
  setIsOpenGamesModal: (isOpenGamesModal) => set({ isOpenGamesModal }),
}));

export default useModalsStore;
